import LoadingSpinner from "../LoadingSpinner";
import Dropdown from "../input/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { localStorageKeys } from "../../const";
import Toggle from "../input/Toggle";
import React from "react";
import { missionControlActions } from "../../store/mission-control/mission-control-slice";

const MapSettings = ({ isLoading }) => {
  const mapSettings = useSelector((state) => state.missionControl.mapSettings);
  const dispatch = useDispatch();

  return (
    <div
      className="ui form"
      style={{
        height: "84.5vh",
        width: "400px",
        borderRadius: "10px",
        background: "transparent",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255, 255, 255, 0.25)",
      }}
    >
      <div
        className="ui segment"
        style={{
          height: "84.5vh",
          borderRadius: "10px",
          background: "rgba(255, 255, 255, 0.8)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.25)",
        }}
      >
        <h4 className="ui dividing header">Map Settings</h4>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <Dropdown
              style={{
                outline: "none",
                height: "20px",
                boxShadow:
                  " 0 4px 8px rgba(0, 0, 0, 0.1),0 6px 20px rgba(0, 0, 0, 0.1)",
              }}
              options={[
                { key: 1, text: "Google", value: 1 },
                { key: 2, text: "Open Street", value: 2 },
              ]}
              label="Map"
              value={mapSettings.map}
              clearable={false}
              onChange={(e, data) => {
                localStorage.setItem(
                  localStorageKeys.MAP_SETTINGS.MAP,
                  data.value,
                );
                window.location.reload();
              }}
            />
            <div
              className="ui segment"
              style={{ background: "rgba(255, 255, 255, 0.8)" }}
            >
              <div className="mission-control-map-popup-footer">
                <div className="mission-control-map-popup-footer-segment">
                  <h5>Avoid Highway</h5>
                </div>
                <div className="mission-control-map-popup-footer-segment">
                  <Toggle
                    value={mapSettings.avoidHighways}
                    onChange={() => {
                      dispatch(missionControlActions.toggleAvoidHighway());
                    }}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MapSettings;
